import React, { Component } from 'react';
import { Platform } from 'react-native';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';

import { codePush } from './modules';
import configureStore from './store';
import MainIndex from './main/MainIndex';

console.disableYellowBox = true;

const {persistor, store} = configureStore();

class App extends Component {

  constructor () {
    super();
  }

  render () {
    return (
      <Provider
        store={store}>
        <PersistGate
          persistor={persistor}>
          <MainIndex/>
        </PersistGate>
      </Provider>
    );
  }
}

if (Platform.OS === 'web') {

} else {
  console.log('add code push to app');
  const codePushOptions = {
    checkFrequency: codePush.CheckFrequency.ON_APP_RESUME,
    installMode: codePush.InstallMode.IMMEDIATE,
  };
  App = codePush(codePushOptions)(App);
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js